/* eslint-disable import/order */
import React from 'react';
import { advancedRoadmapsPlanPageInitialChecksResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { planExportPageRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/planExportPageRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazyAdvancedRoadmapsPlanExport } from './ui/plan-export/index.tsx';
import { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';
import type { Route } from '@atlassian/react-resource-router';

/**
 * Export Page
 */

const ExportPageComponent = () => <LazyAdvancedRoadmapsPlanExport />;

const ExportPage = () => (
	<LazyPage Page={ExportPageComponent} pageId="advanced-roadmap" shouldShowSpinner />
);

export const planExportPageRouteEntry: Route = createEntry(planExportPageRoute, () => ({
	group: 'software',
	ufoName: 'software-advanced-roadmaps-scenario-export',
	// eslint-disable-next-line no-restricted-syntax
	component: ExportPage,
	layout: { isChromeless: true, globalComponents: [], rightSidebars: [] },
	resources: [...jiraSpaResources(), advancedRoadmapsPlanPageInitialChecksResource],
	forPaint: [LazyPlanTimeline],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
